import {Component, OnDestroy, OnInit} from '@angular/core';
import {ConsentService} from "./service/consent.service";
import {Subscription} from "rxjs";
import {ActivatedRoute, Router, NavigationEnd} from "@angular/router";
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  headerTitle = '';
  logoUrl = '';
  paramId = '';
  private subscriptions: Subscription[] = [];

  constructor(
    private consentService: ConsentService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.subscriptions.push(
      this.consentService.getLogoUrlObservable().subscribe(logoUrl => {
        this.logoUrl = logoUrl;
      })
    );

    this.subscriptions.push(
      this.consentService.getHeaderTitleObservable().subscribe(headerTitle => {
        this.headerTitle = headerTitle;
      })
    );

    // S'abonner aux événements de navigation terminés
    this.subscriptions.push(
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        // Obtenir le premier segment d'URL, qui est notre paramId
        const urlSegments = this.router.url.split('/');
        if (urlSegments.length > 1 && urlSegments[1] !== 'error') {
          this.paramId = urlSegments[1];
          this.consentService.updateGroup(this.paramId);

          const loadedFromLocal = this.consentService.loadConfigFromLocal(this.paramId);

          if (!loadedFromLocal) {
            // Sinon charge depuis le backend
            this.consentService.getConfig(this.paramId).subscribe(config => {
              console.log('Config chargée depuis le backend:', config);
            });
          } else {
            console.log('Config chargée depuis le LocalStorage.');
          }
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  navigateToLoginPage() {
    // Navigue de façon absolue vers /{paramId}/login
    this.router.navigate(['/', this.paramId, 'login']);
  }

}
